import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [displayCommodities, setDisplayCommodities] = useParameter<number[]>("@commodities_display");
  const [units, setUnits] = useParameter<number[]>("@units");

  useEffect(() => {
    setParameters(title, {
      "@commodities": commodities,
      "@units": units,
      "@commodities_display": displayCommodities,
    });
  }, [title, commodities, units, displayCommodities, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      setCommodities(parameters["@commodities"].map(Number));
      setUnits(parameters["@units"].map(Number));
      setDisplayCommodities(parameters["@commodities_display"].map(Number));
    },
    [setCommodities, setUnits, setDisplayCommodities]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);
}
